<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("processmente.title") }}</h1>
    <b-tabs content-class="mt-3">
      <!-- 検索欄 -->
      <b-tab :title="this.$i18n.t('processmente.tab_search')" active>
        <b-card class="w-50 mb-3">
          <form>
            <b-form-group
              id="processIdSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('processmente.label_process_id')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="processIdSearch" :placeholder="this.$i18n.t('processmente.placeholder_process_id')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="processNameSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('processmente.label_process_name')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="processNameSearch" :placeholder="this.$i18n.t('processmente.placeholder_process_name')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="processTypeListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('processmente.label_process_type')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processTypeListSearch" :options="searchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <!-- 検索ボタン -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("processmente.button_search") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearch">
          <b-row class="d-flex align-items-center">
            <b-col sm="2" md="2" class="my-1">
              <!-- アクション -->
              <b-dropdown right variant="primary" :text=lblAction>
                <b-dropdown-item @click="valid" >{{ $i18n.t("processmente.button_valid") }}</b-dropdown-item>
                <b-dropdown-item @click="invalid" >{{ $i18n.t("processmente.button_invalid") }}</b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col sm="2" md="2" class="my-1">
              <div>{{ $i18n.t("processmente.label_num_of_disp") }}
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                  style="width: auto"
                ></b-form-select>
              </div>
            </b-col>
            <b-col sm="8" md="8" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="items"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:head(action)="row">
              <b-form inline>
                <b-form-checkbox size="lg" :checked="isAllSelected" v-on:change="selectAll" name="check-button"></b-form-checkbox>
              </b-form>
            </template>
            <template v-slot:cell(action)="row">
              <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectOne(row.item.index)"  name="check-button"></b-form-checkbox>
            </template>
            <template v-slot:cell(edit)="row">
              <!-- 編集ボタン -->
              <b-button v-if="row.item.efFlg === '1'" size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("processmente.button_edit") }}</b-button>
              <b-button v-if="row.item.efFlg === '0'" disabled=true size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("processmente.button_edit") }}</b-button>
            </template>
          </b-table>
        </b-card>
      </b-tab>
      <!-- 新規登録 -->
      <b-tab :title="this.$i18n.t('processmente.tab_register')">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="processId"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('processmente.label_process_id_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="processIdForm" :placeholder="this.$i18n.t('processmente.placeholder_process_id')" maxlength="4"></b-form-input>
            </b-form-group>
            <b-form-group
              id="processName"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('processmente.label_process_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="processNameForm" :placeholder="this.$i18n.t('processmente.placeholder_process_name')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="processTypeList"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('processmente.label_process_type_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processTypeListForm" :options="options" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("processmente.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
      <!-- 表示順変更 -->
      <b-tab :title="this.$i18n.t('processmente.tab_disp_order')" @click="createdDispNumChange">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="dispNumList"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('processmente.label_disp_order')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processSelected" :options="dispNumOptions" :select-size="10" ></b-form-select>
              <b-button variant="secondary" class="float-right px-5" @click="downDisp">↓{{ $i18n.t("processmente.button_down") }}</b-button>
              <b-button variant="secondary" class="float-right px-5" @click="upDisp">↑{{ $i18n.t("processmente.button_up") }}</b-button>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist2" class="float-right px-5">{{ $i18n.t("processmente.button_change_order") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
    </b-tabs>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('processmente.info_register')" :titleMsg="this.$i18n.t('processmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-confirm2" :msg="this.$i18n.t('processmente.info_disp_order')" :titleMsg="this.$i18n.t('processmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm2"/>
    <confirm-modal modId="md-confirm3" :msg="this.$i18n.t('processmente.info_valid')" :titleMsg="this.$i18n.t('processmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="validConfirm"/>
    <confirm-modal modId="md-confirm4" :msg="this.$i18n.t('processmente.info_invalid')" :titleMsg="this.$i18n.t('processmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="invalidConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })

    // 更新画面から戻った場合は再検索
    var searchFlg = this.$route.query.searchFlg
    if (searchFlg !== undefined) {
      if (searchFlg[0] === 1) {
        // 配列として渡されてしまうため先頭の値のみ取得
        var tmp = this.$route.query.searchProcessId
        this.processIdSearch = tmp[0]
        tmp = this.$route.query.searchProcessName
        this.processNameSearch = tmp[0]
        tmp = this.$route.query.searchProcessTypeId
        this.processTypeListSearch = tmp[0]
        this.search()
      }
    }
  },
  data () {
    return {
      processIdForm: null,
      processNameForm: null,
      dispNumList: null,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      fields: [
        { key: 'action', label: '' },
        { key: 'processId', label: this.$i18n.t('processmente.label_process_id'), sortable: true },
        { key: 'processName', label: this.$i18n.t('processmente.label_process_name'), sortable: true },
        { key: 'processTypeStr', label: this.$i18n.t('processmente.label_process_type'), sortable: true },
        { key: 'uOp', label: this.$i18n.t('processmente.label_register_user'), sortable: true },
        { key: 'uDate', label: this.$i18n.t('processmente.label_register_date'), sortable: true },
        { key: 'efFlgStr', label: this.$i18n.t('processmente.label_ef_flg'), sortable: true },
        { key: 'edit', label: this.$i18n.t('processmente.button_edit') }
      ],
      items: [],
      searchOptions: [
        { value: '', text: this.$i18n.t('processmente.label_all_process_type') },
        { value: '1', text: this.$i18n.t('processmente.label_test_process') },
        { value: '2', text: this.$i18n.t('processmente.label_pass_process') }
      ],
      processTypeListSearch: '',
      processTypeListForm: '',
      options: [
        { value: '', text: this.$i18n.t('processmente.label_select') },
        { value: '1', text: this.$i18n.t('processmente.label_test_process') },
        { value: '2', text: this.$i18n.t('processmente.label_pass_process') }
      ],
      dispNumOptions: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      isAllSelected: false,
      selectedItems: [],
      lblAction: this.$i18n.t('processmente.button_action'),
      processSelected: null,
      errMsg: null,
      errSbj: null
    }
  },
  methods: {
    search: function () {
      // リクエスト
      var reqObj = {}
      var processIdStr = this.processIdSearch
      if (processIdStr == null) {
        processIdStr = ''
      }
      var processNameStr = this.processNameSearch
      if (processNameStr == null) {
        processNameStr = ''
      }
      var processTypeListStr = this.processTypeListSearch
      if (processTypeListStr == null) {
        processTypeListStr = ''
      }

      reqObj.processId = processIdStr
      reqObj.processIdLikeFlg = '1'
      reqObj.processName = processNameStr
      reqObj.processType = processTypeListStr
      reqObj.efFlg = ''

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var processList = res.data.processInfo
            var processes = []
            if (processList.length === 0) {
              this.errSbj = this.$i18n.t('processmente.title')
              this.errMsg = this.$i18n.t('processmente.err_not_data')
              this.$bvModal.show('md-err')
              this.isSearch = false
              return
            }

            // 整形
            for (var i = 0; i < processList.length; i++) {
              var process = {}
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(processList[i].u_date, 'YYYY-MM-DD HH:mm:ss')
              var output = null
              if (String(utc) === 'Invalid date') {
                output = ''
              } else {
                // local時刻に変換＆フォーマット
                output = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              process.processId = processList[i].process_id
              process.processName = processList[i].process_name
              process.processType = processList[i].process_type
              if (processList[i].process_type === '1') {
                process.processTypeStr = this.$i18n.t('processmente.label_test_process')
              } else {
                process.processTypeStr = this.$i18n.t('processmente.label_pass_process')
              }
              process.uOp = processList[i].u_op_name
              process.uDate = output
              // TODO json
              process.edit = this.$i18n.t('processmente.label_edit')
              process.efFlg = processList[i].ef_flg
              if (processList[i].ef_flg === '1') {
                // TODO json
                process.efFlgStr = this.$i18n.t('processmente.label_valid')
              } else {
                // TODO json
                process.efFlgStr = this.$i18n.t('processmente.label_invalid')
                process.status = 'awesome'
              }
              process.selectedFlg = false
              process.index = i
              processes.push(process)
            }
            // ページング設定
            this.totalRows = processes.length
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...processes)
            // 検索結果表示
            this.isSearch = true
            // 全選択チェック
            this.isAllSelected = false
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      // 入力値チェック
      if (this.processIdForm === null || this.processIdForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_id_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkNum(this.processIdForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_id_number')
        this.$bvModal.show('md-err')
        return
      }
      if (this.processNameForm === null || this.processNameForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.processNameForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_name_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (this.processTypeListForm === null || this.processTypeListForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_type_hissu')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.processId = this.processIdForm
      reqObj.processName = this.processNameForm
      reqObj.processType = this.processTypeListForm

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/register', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist2: function () {
      // 表示順変更
      var processId = []
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        processId.push(String(this.dispNumOptions[i].value))
      }
      var body = {}
      body.processId = processId

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/updateDispOrder', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm2')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.processIdForm = null
      this.processNameForm = null
      this.processTypeListForm = null
      this.$bvModal.hide('md-confirm')
    },
    registConfirm2: function () {
      this.$bvModal.hide('md-confirm2')
    },
    valid: function () {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(String(this.items[i].processId))
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '1'
      reqObj.processId = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm3')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    invalid: function () {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(String(this.items[i].processId))
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '0'
      reqObj.processId = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm4')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validConfirm: function () {
      this.$bvModal.hide('md-confirm3')
    },
    invalidConfirm: function () {
      this.$bvModal.hide('md-confirm4')
    },
    edit: function (item, index, button) {
      // 検索結果保持(戻るボタン対応)
      var processIdStr = this.processIdSearch
      if (processIdStr == null) {
        processIdStr = ''
      }
      var processNameStr = this.processNameSearch
      if (processNameStr == null) {
        processNameStr = ''
      }
      var processTypeListStr = this.processTypeListSearch
      if (processTypeListStr == null) {
        processTypeListStr = ''
      }
      this.$store.store.state.searchProcessId = processIdStr
      this.$store.store.state.searchProcessName = processNameStr
      this.$store.store.state.searchProcessTypeId = processTypeListStr

      // 編集データ
      this.$store.store.state.processId = item.processId
      this.$store.store.state.processName = item.processName
      this.$store.store.state.processType = item.processType
      this.$router.push({ path: 'processmenteEdit' })
    },
    rowClass: function (item, type) {
      if (!item) return
      if (item.status === 'awesome') return 'table-danger'
    },
    selectAll () {
      if (this.isAllSelected) {
        this.isAllSelected = false
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].selectedFlg = false
        }
      } else {
        this.isAllSelected = true
        for (var j = 0; j < this.items.length; j++) {
          this.items[j].selectedFlg = true
        }
      }
    },
    selectOne (index) {
      this.items[index].selectedFlg = !this.items[index].selectedFlg
      var selectedCnt = 0
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          selectedCnt++
        }
      }
      if (selectedCnt !== this.items.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    },
    createdDispNumChange () {
      var body = {}

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 表示順整形
            var processInfoList = res.data.processInfo
            var dispNumOptions = []
            for (var i = 0; i < processInfoList.length; i++) {
              var dispNumOption = {}
              dispNumOption.value = processInfoList[i].process_id
              dispNumOption.text = processInfoList[i].process_name
              dispNumOptions.push(dispNumOption)
            }
            this.dispNumOptions.splice(0)
            this.dispNumOptions.splice(0, 0, ...dispNumOptions)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    downDisp: function () {
      if (this.processSelected === null) {
        return
      }
      // iで表示順を取得
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        if (this.processSelected === this.dispNumOptions[i].value) {
          break
        }
      }
      // 順序を入れ替え
      var selectedProcessInfo = this.dispNumOptions[i]
      if (i !== (this.dispNumOptions.length - 1)) {
        var exchangeProcessInfo = this.dispNumOptions[i + 1]
        this.dispNumOptions.splice(i, 1, exchangeProcessInfo)
        this.dispNumOptions.splice(i + 1, 1, selectedProcessInfo)
      }
    },
    upDisp: function () {
      if (this.processSelected === null) {
        return
      }
      // iで表示順を取得
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        if (this.processSelected === this.dispNumOptions[i].value) {
          break
        }
      }
      // 順序を入れ替え
      var selectedProcessInfo = this.dispNumOptions[i]
      if (i !== 0) {
        var exchangeProcessInfo = this.dispNumOptions[i - 1]
        this.dispNumOptions.splice(i, 1, exchangeProcessInfo)
        this.dispNumOptions.splice(i - 1, 1, selectedProcessInfo)
      }
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Processmente.vue